import { Pagination } from "@mantine/core";

export const BasePagination = Pagination;
